import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { userIsSubscriber } from 'components/Utils/theme';
import { useTelemedicina } from 'context/TelemedicinaContext';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelConfirmacao = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AccountContext);
  const assinante = userIsSubscriber(user);
  const { paciente, agendamento, medicoSelecionado: medico, setAgendamento } = useTelemedicina();
  const [error, setError] = useState(null);
  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');

  let data_parcela = '';
  if (user.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }
  const dataAtual = new Date();
  const clientePendente = user?.loggedIn && user?.qntdeParcelas?.countParcelas && user?.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela;

  async function fetchAgendamento() {
    try {
      return;
      setLoading(true);
      await api(`${ENDPOINT}/clients/verificaFaltasAtendimento/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: paciente.cpf }),
      })
        .then(async (res) => {
          return res.json();
        })
        .then(async (resposta) => {
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  }

  const lockAgenda = async () => {
    try {
      const url = ENDPOINT + '/schedule/lockByAgendaExames/' + agendamento.agenda_exames_id + '/' + paciente.cpf;
      const response = await api(url, {
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        method: 'GET',
      });
      const postsData = await response.json();
      return postsData.success;
    } catch (error) {
      console.log(error);
    }
  };

  async function fetchAgendamentoEspecialista() {
    try {
      const lock = await lockAgenda();
      if (!lock) {
        setError(true);
        return;
      }

      await api(`${ENDPOINT}/pacientes/`, {
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({
          username: paciente.cpf,
          agendamento_id: agendamento.agenda_exames_id,
          assinante: assinante,
          procedimentoId: agendamento.procedimento_id,
          plano_id: user.id_plano,
          tipo: 'especialista',
          especialidadeId: agendamento.especialidadeId,
        }),
      })
        .then(async (res) => {
          if (res.status !== 200) {
            setError(true);
          }
          return res.json();
        })
        .then(async (resposta) => {
          if (resposta && resposta.pacienteId !== null) {
            setLoading(false);
            if (Number(resposta.valor) === 0) {
              navigate('/atendimento/loading/', {
                state: {
                  valor: 0,
                  paciente: { paciente_id: paciente.paciente_id, cpf: paciente.cpf },
                  agenda: { AVAILABILITY_LID: agendamento.agenda_exames_id, AVA_DATE: agendamento.data, AVA_START_TIME: agendamento.horario },
                  medico: medico,
                  orientacoes: null,
                  confim: true,
                  transaction_id: 9999999,
                  procedimentoId: agendamento.procedimento_id,
                  procedimento: agendamento.procedimento,
                  product_name: agendamento.ACTIVITY_NAME,
                  paid: true,
                  forma_pgto: 'DINHEIRO',
                  valorExtraPsicologo: false,
                  valor_extra_psicologo: false,
                  especialista_id: agendamento.especialidadeId,
                  item: {
                    especialista_id: agendamento.especialidadeId,
                  },
                },
              });
              return;
            }

            navigate('/pagamentos', {
              state: {
                modalidade: 'especialista online',
                parcelsActive: true,
                valor: resposta.valor,
                expiration_pix_in_min: 5,
                service: 'schedule',
                navig_to: '/alerts/sucesso/agendamento/',
                triagem: true,
                valor_assinante: Number(medico?.horarios?.[0]?.procedimentos?.[0]?.valor || 0).toFixed(2),
                item: {
                  cpf: onlyNumbers(paciente.cpf),
                  nome: paciente.nome,
                  fone: paciente.celular ? paciente.celular : paciente.telefone,
                  email: paciente.email,
                  scheduleId: agendamento.agenda_exames_id,
                  procedimento_convenio_id: agendamento.procedimento_id,
                  product_name: medico.horarios[0].procedimentos[0].nome,
                  confim: true,
                  orcamento_id: null,
                  agenda_exames_id: agendamento.agenda_exames_id,
                  especialidade_id: agendamento.especialidadeId,
                  medico_id: medico.medico.medico,
                  modalidade: 'especialista online',
                  valor_com_desconto: Number(medico?.horarios?.[0]?.procedimentos?.[0]?.valor || 0).toFixed(2),
                },
                frequenciaText: `Telemedicina ${
                  medico?.medico?.especialidade
                    ? medico.medico.especialidade
                        .trim()
                        .toLowerCase()
                        .replace(/^\w/, (c) => c.toUpperCase())
                    : ''
                }
`,
              },
            });
          }
        });
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAgendamento();
  }, []);

  return {
    loading,
    navigate,
    paciente,
    assinante,
    medico,
    clientePendente,
    fetchAgendamentoEspecialista,
    error,
    agendamento,
    user,
  };
};

export default useModelConfirmacao;
